import * as React from "react";
import {InputDialogBase} from "../../Dialogs/InputDialogBase";


export interface AbsCodeCIEnbaleProps extends React.Props<AbsCodeCIEnablePanel>{
}

export interface AbsCodeCIEnbaleState {
}

export class AbsCodeCIEnablePanel extends React.Component<AbsCodeCIEnbaleProps, AbsCodeCIEnbaleState> {
  constructor(props: AbsCodeCIEnbaleProps) {
    super(props);
    this.state = { };
  }

  public render(): JSX.Element {
    return (
      <div className="dialog-panel">
        <h2>Enable continuous deployment</h2>
        <p>
          After enabling, be sure to modify your code through continuous deployment and not through other mechanisms to avoid conflicts.
        </p>
        <div className="button-panel">
            <button type="button" className="cancel-button">Cancel</button>
            <button type="button" className="ok-button light-button">Got it</button>
        </div>        
      </div>);
  }
}


// WEBPACK FOOTER //
// ./Client/v4/Views/AbsCodeCIEnablePanel.tsx